export default {
	LAYOUT_DISABLED: 'Select a group to be able to add a tile'
};
